import { isRTL } from '@ms/yammer-i18n';
import type { PseudolocMode } from '@ms/yammer-i18n';

import { useI18nStore } from '../state/i18nStore';

type UseCurrentLocale = () => string;
export const useCurrentLocale: UseCurrentLocale = () => useI18nStore((state) => state.currentLocale);

type UseRequestedLocale = () => string;
export const useRequestedLocale: UseRequestedLocale = () => useI18nStore((state) => state.requestedLocale);

type UsePseudolocMode = () => PseudolocMode;
export const usePseudolocMode: UsePseudolocMode = () => useI18nStore((state) => state.pseudolocMode);

type SetPseudolocMode = (mode: PseudolocMode) => void;
export const setPseudolocMode: SetPseudolocMode = (mode) => {
  useI18nStore.setState({ pseudolocMode: mode });
};

type UseIsCurrentLocaleRTL = () => boolean;
export const useIsCurrentLocaleRTL: UseIsCurrentLocaleRTL = () => useI18nStore((state) => isRTL(state.currentLocale));

type CurrentLocaleDirection = () => 'rtl' | 'ltr';
export const useCurrentLocaleDirection: CurrentLocaleDirection = () => {
  const isRTL = useIsCurrentLocaleRTL();

  return isRTL ? 'rtl' : 'ltr';
};
